import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeatureFlagGuard } from '../core/features/feature-flag.guard';
import { FEATURE_FLAGS } from '../data/models/models';
import { ReservationPage } from './reservation.page';

const routes: Routes = [
  {
    path: '',
    component: ReservationPage,
    canActivate: [FeatureFlagGuard],
    data: { feature: FEATURE_FLAGS.RESERVATIONS },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReservationRoutingModule { }
